import Vue from 'vue';
import base from '@/utils/base' // 全局方法
import Router from 'vue-router';
import VueResource from 'vue-resource';
import ECharts from 'vue-echarts';
import { routes } from '@/routers';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as utils from '@/utils/util';
import * as login from '@/utils/login';
import app from './App';

Vue.use(base);
Vue.use(ElementUI);
Vue.use(Router);
Vue.use(VueResource);
Vue.component('chart', ECharts);

const router = new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})

router.beforeEach((to, from, next) => {
  // console.log('to: ', to);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let loginData = login.getUserInfo();
    let session = login.getSession();
    // 有登录态
    if (session && loginData) {
      // 没有权限信息
      if (!loginData || !loginData.role) {
        // 清空用户信息
        login.logout();
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
        // 获取当前账户权限
        // api.initUserInfo().then(res => {
        //   // 构造路由
        //   let addRouters = filterAsyncRouter(asyncRouterMap, [res.role]);
        //   addRouters = constantRouterMap.concat(addRouters)
        //   router.addRoutes(addRouters);
        //   next({ ...to, replace: true });
        // }, rej => {
        //   // 清空用户信息
        //   window.myVue.logout();
        //   next({
        //     path: '/login',
        //     query: { redirect: to.fullPath }
        //   });
        // });
      } else {
        next();
      }
    } else {
      // 清空用户信息
      login.logout();
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }

  } else {
    next();
  }
})

router.afterEach(() => {

})

const myVue = new Vue({
  el: '#app',
  router,
  render: h => h(app),
});

window.myVue = myVue;

// console.log(window.myVue);



// WEBPACK FOOTER //
// ./src/main.js